export const zeroFill = (number: number, len: number) => {
    let zeros = '0'.repeat(len);
    let str = zeros + String(number)
    return str.slice(-len)
}
